import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';

export class Impostazioni {
  codice_fiscale: string;
  nome: string;
  intervallo: NgbTimeStruct;
  inizio_giornata: NgbTimeStruct;
  fine_giornata: NgbTimeStruct;
  mostra_weekend: boolean;
  vista: string;
  visualizza_titolare: boolean;
  specializzazione?: string;
}



// WEBPACK FOOTER //
// ./src/app/model/impostazioni_agenda.ts